import { Injectable } from '@angular/core';
import { gql, Query } from 'apollo-angular';

@Injectable({
  providedIn: 'root',
})
export class GetCartQuery extends Query<{
  cart: {
    totalItemsQuantity: number;
  };
}> {
  // eslint-disable-next-line
  override document = gql`
    query getCart {
      cart {
        totalItemsQuantity
      }
    }
  `;
}
